import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', type = 'text', ...props }, ref) => {
    const baseStyles = 'w-full rounded-md border border-rm-neutral-600/30 bg-white px-4 py-2 text-rm-ink-900 placeholder:text-rm-neutral-600/80 focus:outline-none focus:ring-2 focus:ring-rm-accent-500 disabled:cursor-not-allowed disabled:opacity-50';
    
    const classes = [baseStyles, className].filter(Boolean).join(' ');

    return (
      <input
        type={type}
        className={classes}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
export type { InputProps };
